import React from 'react';
import { motion } from 'framer-motion';
import { FiPlus, FiGrid, FiList, FiEdit2, FiTrash2, FiSearch } from 'react-icons/fi';

const productsData = [
  { id: 1, name: 'Premium Coffee Beans', category: 'Raw Material', price: '$24.99', stock: 150, image: 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=300' },
  { id: 2, name: 'Latte Art Set', category: 'Equipment', price: '$89.00', stock: 45, image: 'https://images.unsplash.com/photo-1534706936160-d5ee67737249?w=300' },
  { id: 3, name: 'Eco-Friendly Cups', category: 'Packaging', price: '$12.50', stock: 2500, image: 'https://images.unsplash.com/photo-1517701604599-bb29b565090c?w=300' },
  { id: 4, name: 'Espresso Machine', category: 'Equipment', price: '$1,200.00', stock: 12, image: 'https://images.unsplash.com/photo-1513267048331-5611cad82e4f?w=300' },
];

const Products = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="container-fluid p-0"
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold mb-1">Product Catalog</h2>
          <p className="text-muted small mb-0">Manage global products and sync inventory across branches.</p>
        </div>
        <button className="btn btn-primary d-flex align-items-center gap-2 px-3">
          <FiPlus /> Add New Product
        </button>
      </div>

      <div className="row mb-4 g-3">
        <div className="col-md-6 col-lg-4">
          <div className="input-group">
            <span className="input-group-text bg-transparent border-end-0 text-muted"><FiSearch /></span>
            <input type="text" className="form-control border-start-0 ps-0" placeholder="Search products..." />
          </div>
        </div>
        <div className="col-md-6 col-lg-8 d-flex justify-content-md-end gap-2">
          <button className="btn glass-card border-0 text-white px-3"><FiGrid /> Grid</button>
          <button className="btn glass-card border-0 text-muted px-3"><FiList /> List</button>
          <select className="form-select glass-card border-0 text-white" style={{ width: '180px' }}>
            <option>All Categories</option>
            <option>Equipment</option>
            <option>Raw Material</option>
            <option>Packaging</option>
          </select>
        </div>
      </div>

      <div className="row g-4">
        {productsData.map((product) => (
          <div key={product.id} className="col-xl-3 col-lg-4 col-md-6">
            <motion.div 
              whileHover={{ y: -10 }}
              className="glass-card overflow-hidden h-100"
            >
              <div className="position-relative" style={{ height: '200px' }}>
                <img 
                  src={product.image} 
                  className="w-100 h-100 object-fit-cover" 
                  alt={product.name} 
                />
                <div className="position-absolute top-0 end-0 p-2">
                  <span className="badge bg-dark bg-opacity-50 backdrop-blur-sm">
                    {product.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h5 className="fw-bold mb-1">{product.name}</h5>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="text-primary fw-bold fs-5">{product.price}</span>
                  <span className={`small ${product.stock < 50 ? 'text-danger' : 'text-muted'}`}>
                    Stock: {product.stock}
                  </span>
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-sm glass-card border-0 text-white flex-grow-1 py-2 d-flex align-items-center justify-content-center gap-2">
                    <FiEdit2 size={14} /> Edit
                  </button>
                  <button className="btn btn-sm glass-card border-0 text-danger py-2 px-3">
                    <FiTrash2 size={14} />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default Products;
